module.exports = __webpack_public_path__ + "img/doc-invalid.090dee46.svg";